'use strict';

var getBusinessObject = require('bpmn-js/lib/util/ModelUtil').getBusinessObject;
var domQuery = require('min-dom').query;
var entryFactory = require('../../../../factory/EntryFactory');

var elementHelper = require('../../../../helper/ElementHelper'),
    cmdHelper = require('../../../../helper/CmdHelper');

var domClasses = require('min-dom').classes;

/**
 * Get a property value of the loop characteristics.
 *
 * @param {djs.model.Base} element
 * @param {string} propertyName
 *
 * @return {any} the property value
 */
function getProperty(element, propertyName) {
  var loopCharacteristics = getLoopCharacteristics(element);
  return loopCharacteristics && loopCharacteristics.get(propertyName);
}

/**
 * Get the body of a given expression.
 *
 * @param {ModdleElement<bpmn:FormalExpression>} expression
 *
 * @return {string} the body (value) of the expression
 */
function getBody(expression) {
  return expression && expression.get('body');
}


/**
 * Get the loop characteristics of an element.
 *
 * @param {djs.model.Base} element
 *
 * @return {ModdleElement<bpmn:MultiInstanceLoopCharacteristics>} the loop characteristics
 */
function getLoopCharacteristics(element) {
  var bo = getBusinessObject(element);
  return bo.loopCharacteristics;
}

/**
 * Get the loop cardinality of the loop characteristics.
 *
 * @param {djs.model.Base} element
 *
 * @return {ModdleElement<bpmn:FormalExpression>} an expression representing the loop cardinality
 */
function getLoopCardinality(element) {
  return getProperty(element, 'loopCardinality');
}

/**
 * Get the loop cardinality value of the loop characteristics.
 *
 * @param {djs.model.Base} element
 *
 * @return {string} the loop cardinality value
 */
function getLoopCardinalityValue(element) {
  var loopCardinality = getLoopCardinality(element);
  return getBody(loopCardinality);
}

/**
 * Get the completion condition of the loop characteristics.
 *
 * @param {djs.model.Base} element
 *
 * @return {ModdleElement<bpmn:FormalExpression>} an expression representing the completion condition
 */
function getCompletionCondition(element) {
  return getProperty(element, 'completionCondition');
}

/**
 * Get the completion condition value of the loop characteristics.
 *
 * @param {djs.model.Base} element
 *
 * @return {string} the completion condition value
 */
function getCompletionConditionValue(element) {
  var completionCondition = getCompletionCondition(element);
  return getBody(completionCondition);
}

/**
 * Get the 'camunda:collection' attribute value of the loop characteristics.
 *
 * @param {djs.model.Base} element
 *
 * @return {string} the 'camunda:collection' value
 */
function getCollection(element) {
  return getProperty(element, 'camunda:collection');
}

/**
 * Get the 'camunda:elementVariable' attribute value of the loop characteristics.
 *
 * @param {djs.model.Base} element
 *
 * @return {string} the 'camunda:elementVariable' value
 */
function getElementVariable(element) {
  return getProperty(element, 'camunda:elementVariable');
}


/**
 * Creates 'bpmn:FormalExpression' element.
 *
 * @param {ModdleElement} parent
 * @param {string} body
 * @param {BpmnFactory} bpmnFactory
 *
 * @result {ModdleElement<bpmn:FormalExpression>} a formal expression
 */
function createFormalExpression(parent, body, bpmnFactory) {
  return elementHelper.createElement('bpmn:FormalExpression', { body: body }, parent, bpmnFactory);
}

/**
 * Updates a specific formal expression of the loop characteristics.
 *
 * @param {djs.model.Base} element
 * @param {string} propertyName
 * @param {string} newValue
 * @param {BpmnFactory} bpmnFactory
 */
function updateFormalExpression(element, propertyName, newValue, bpmnFactory) {
  var loopCharacteristics = getLoopCharacteristics(element);

  var expressionProps = {};

  if (!newValue) {
    // remove formal expression
    expressionProps[propertyName] = undefined;
    return cmdHelper.updateBusinessObject(element, loopCharacteristics, expressionProps);
  }

  var existingExpression = loopCharacteristics.get(propertyName);

  if (!existingExpression) {
    // add formal expression
    expressionProps[propertyName] = createFormalExpression(loopCharacteristics, newValue, bpmnFactory);
    return cmdHelper.updateBusinessObject(element, loopCharacteristics, expressionProps);
  }

  // edit existing formal expression
  return cmdHelper.updateBusinessObject(element, existingExpression, {
    body: newValue
  });
}


module.exports = function(element, bpmnFactory, translate) {

  var entries = [];

  // error message /////////////////////////////////////////////////////////////////

  // entries.push({
    // id: 'multiInstance-errorMessage',
    // html: '<div data-show="isValid">' +
             // '<span class="bpp-icon-warning"></span> ' +
             // translate('Must provide either loop cardinality or collection') +
          // '</div>',

    // isValid: function(element, node, notification, scope) {
      // var loopCharacteristics = getLoopCharacteristics(element);

      // var isValid = true;
      // if (loopCharacteristics) {
        // var loopCardinality = getLoopCardinalityValue(element);
        // var collection = getCollection(element);

        // isValid = !loopCardinality && !collection;
      // }

      // domClasses(node).toggle('bpp-hidden', !isValid);
      // domClasses(notification).toggle('bpp-error-message', isValid);

      // return isValid;
    // }
  // });
	
	
	
  entries.push({
    id: 'custom_instance_loop',
    label: translate(''),
    html: '<div class="bpp-row">' +
              '<label for="variable_max_number_instances">'+translate('Select Variable to guide the max number of Instances')+'</label>' +
              '<div class="bpp-field-wrapper">' +
                '<select id="variable_max_number_instances" name="variable_max_number_instances" data-value>' +
					'<option value="" selected>' + translate("None") + '</option>' +
                '</select>' +
              '</div>' +
            '</div>' +
			
			'<div class="bpp-row" data-show="showVariableAdditionalExpression">' +
              '<label for="variable_additional_expression">'+translate('Variable Additional Expression')+'</label>' +
              '<div class="bpp-field-wrapper">'+
                '<input id="variable_additional_expression" type="text" name="variable_additional_expression" />' +
              '</div>' +
            '</div>' +
			
			'<div class="bpp-row" data-show="showMaxNumberOfInstances">' +
              '<label for="max_number_instances">'+translate('Max Number of Instances')+'</label>' +
              '<div class="bpp-field-wrapper">'+
                '<input id="max_number_instances" type="text" name="max_number_instances" />' +
              '</div>' +
            '</div>' +
			
			'<div class="bpp-row">' +
              '<label for="first_variable_exit_condition">'+translate('Select first Variable for exit condition')+'</label>' +
              '<div class="bpp-field-wrapper">' +
                '<select id="first_variable_exit_condition" name="first_variable_exit_condition" data-value>' +
					'<option value="" selected>' + translate("None") + '</option>' +
                '</select>' +
              '</div>' +
            '</div>' +
			
			 '<div class="bpp-row" data-show="showSecondVariableExitCondition">' +
              '<label for="condition_exit_condition">'+translate('Condition')+'</label>' +
              '<div class="bpp-field-wrapper">' +
                '<select id="condition_exit_condition"  name="condition_exit_condition" data-value/>' +
					'<option value="" selected></option>' +
					'<option value=">">' + translate(">") + '</option>' +
					'<option value="<">' + translate("<") + '</option>' +
					'<option value="==">' + translate("=") + '</option>' +
					'<option value=">=">' + translate(">=") + '</option>' +
					'<option value="<=">' + translate("<=") + '</option>' +
					'<option value="!=">' + translate("≠") + '</option>' +
				 '</select>' +
              '</div>' +
            '</div>' + 
			
			'<div class="bpp-row" data-show="showSecondVariableExitCondition">' +
              '<label for="second_variable_exit_condition">'+translate('Select second Variable for exit condition')+'</label>' +
              '<div class="bpp-field-wrapper">' +
                '<select id="second_variable_exit_condition" name="second_variable_exit_condition" data-value>' +
					'<option value="" selected>' + translate("None") + '</option>' +
                '</select>' +
              '</div>' +
            '</div>' +
			
			'<div class="bpp-row" data-show="showConditionValue">' +
              '<label for="condition_value">'+translate('Value')+'</label>' +
              '<div class="bpp-field-wrapper">'+
                '<input id="condition_value" type="text" name="condition_value" />' +
              '</div>' +
            '</div>' 
			,

    get: function(element, propertyName) {
		
		var loopCardinality = "";
		var completionCondition = "";
		if (element.businessObject.loopCharacteristics){
			if (element.businessObject.loopCharacteristics.loopCardinality){
				loopCardinality = element.businessObject.loopCharacteristics.loopCardinality.body;
			}
			if (element.businessObject.loopCharacteristics.completionCondition){
				completionCondition = element.businessObject.loopCharacteristics.completionCondition.body;
			}	
		}
		var values = {};
		  
		values.variable_max_number_instances = document.getElementById('variable_max_number_instances').options[document.getElementById('variable_max_number_instances').selectedIndex].value;
		values.max_number_instances = document.getElementById('max_number_instances').value;
		values.variable_additional_expression = document.getElementById('variable_additional_expression').value;
		  
		values.condition_exit_condition = document.getElementById('condition_exit_condition').options[document.getElementById('condition_exit_condition').selectedIndex].value;
		values.first_variable_exit_condition = document.getElementById('first_variable_exit_condition').options[document.getElementById('first_variable_exit_condition').selectedIndex].value;
		values.second_variable_exit_condition = document.getElementById('second_variable_exit_condition').options[document.getElementById('second_variable_exit_condition').selectedIndex].value;
		values.condition_value = document.getElementById('condition_value').value;
		
		// if (loopCardinality != ""){
			// if (!loopCardinality.includes('${')){
				// values.max_number_instances = loopCardinality;
			// }
			// else{
				// values.max_number_instances = "";
				// if (loopCardinality.includes('.intValue()')){
					// var tmp = loopCardinality.split('.intValue()')[0];
					// tmp = loopCardinality.split('${')[1];
					// values.variable_max_number_instances = tmp;
					// values.variable_additional_expression = loopCardinality.split('.intValue()')[1];
				// }
				
			// }
		// }
		
		return values;
    },

    set: function(element, values, containerElement) {
      
    },

    validate: function(element, values) {
		
		var validationResult = {};
		if (document.getElementById('first_variable_exit_condition') && document.getElementById('first_variable_exit_condition').selectedIndex &&
			document.getElementById('second_variable_exit_condition') && document.getElementById('second_variable_exit_condition').selectedIndex == 0){
			if (!values.condition_value){
				validationResult.condition_value = "Value is required. Otherwise no exit condition will be configured.";
			}
		}
		
      // var validationResult = {};

      // if (!values.condition && values.conditionType === 'expression') {
        // validationResult.condition = 'Must provide a value';
      // }
      // else if (values.conditionType === 'script') {
        // validationResult = script.validate(element, values);
      // }

      return validationResult;
    },
	showSecondVariableExitCondition: function(element, inputNode) {
		var ret = false;
		if (document.getElementById('first_variable_exit_condition') && document.getElementById('first_variable_exit_condition').selectedIndex){
			ret = true;
		}
		return ret;
    },
	showConditionValue: function(element, inputNode){
		var ret = false;
		
		if (document.getElementById('first_variable_exit_condition') && document.getElementById('first_variable_exit_condition').selectedIndex &&
			document.getElementById('second_variable_exit_condition') && document.getElementById('second_variable_exit_condition').selectedIndex == 0){
				ret = true;
		}
		
		return ret;
	},
	showVariableAdditionalExpression: function(element, inputNode){
		var ret = false;
		
		if (document.getElementById('variable_max_number_instances') && document.getElementById('variable_max_number_instances').selectedIndex){
				ret = true;
		}
		
		return ret;
	},
	showMaxNumberOfInstances: function(element, inputNode){
		var ret = false;
		
		if (document.getElementById('variable_max_number_instances') && document.getElementById('variable_max_number_instances').selectedIndex == 0){
				ret = true;
		}
		
		return ret;
	},

  });
  
  // loop cardinality //////////////////////////////////////////////////////////////

  entries.push(entryFactory.textField({
    id: 'multiInstance-loopCardinality',
    label: translate('Loop Cardinality'),
    modelProperty: 'loopCardinality',

    get: function(element, node) {
      return {
        loopCardinality: getLoopCardinalityValue(element)
      };
    },

    set: function(element, values) {
      return updateFormalExpression(element, 'loopCardinality', values.loopCardinality, bpmnFactory);
    }
  }));


  // collection //////////////////////////////////////////////////////////////////

  // entries.push(entryFactory.textField({
    // id: 'multiInstance-collection',
    // label: translate('Collection'),
    // modelProperty: 'collection',

    // get: function(element, node) {
      // return {
        // collection: getCollection(element)
      // };
    // },

    // set: function(element, values) {
      // var loopCharacteristics = getLoopCharacteristics(element);
      // return cmdHelper.updateBusinessObject(element, loopCharacteristics, {
        // 'camunda:collection': values.collection || undefined
      // });
    // },

    // validate: function(element, values, node) {
      // var collection = getCollection(element);
      // var elementVariable = getElementVariable(element);

      // if (!collection && elementVariable) {
        // return { collection : 'Must provide a value' };
      // }
    // }
  // }));


  // element variable ////////////////////////////////////////////////////////////

  // entries.push(entryFactory.textField({
    // id: 'multiInstance-elementVariable',
    // label: translate('Element Variable'),
    // modelProperty: 'elementVariable',

    // get: function(element, node) {
      // return {
        // elementVariable: getElementVariable(element)
      // };
    // },

    // set: function(element, values) {
      // var loopCharacteristics = getLoopCharacteristics(element);
      // return cmdHelper.updateBusinessObject(element, loopCharacteristics, {
        // 'camunda:elementVariable': values.elementVariable || undefined
      // });
    // }
  // }));


  // Completion Condition //////////////////////////////////////////////////////

  entries.push(entryFactory.textField({
    id: 'multiInstance-completionCondition',
    label: translate('Completion Condition'),
    modelProperty: 'completionCondition',

    get: function(element) {
      return {
        completionCondition: getCompletionConditionValue(element)
      };
    },

    set: function(element, values) {
		
      return updateFormalExpression(element, 'completionCondition', values.completionCondition, bpmnFactory);
    }
  }));

  return entries;

};
